<template>
  <section id="contact" class="main-contact">
    <h1 :class="'pt-5 text-xs-center ' + displayTitle">Contacto</h1>
    <v-container class="mb-5">
      <v-layout row wrap class="mb-5">
        <v-flex lg5 class="px-5">
          <form class="pb-5">
            <div class="alert-show">
              <transition name="alert-in">
                <v-alert v-show="alertQuery" color="success" icon="new_releases" :value="true">
                  El correo electronico fue enviado con exito, pronto nos comunicaremos contigo.
                </v-alert>
              </transition>
            </div>
            <v-text-field
              class="py-4"
              label="Nombre"
              v-model="name"
              :error-messages="nameErrors"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
              required
            ></v-text-field>
            <v-text-field
              class="py-4"
              label="Correo Electronico"
              v-model="email"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              required
            ></v-text-field>
            <v-text-field
              class="py-4"
              label="Consulta"
              v-model="query"
              multi-line
              :error-messages="queryErrors"
              @input="$v.query.$touch()"
              @blur="$v.query.$touch()"
              required
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingBtn" color="primary" @click.stop="submit" :small="btnSmall">Enviar</v-btn>
            <v-btn color="secondary" @click.stop="clear" :small="btnSmall">Limpiar</v-btn>
          </form>
        </v-flex>
        <v-flex lg5 offset-lg1 xs12 :class="mapClass">
          <iframe class="mt-3" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7820.946965937237!2d-58.63031749178365!3d-34.49519852287285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcbb4558d53941%3A0x4a50eedaa7f8f645!2sDon+Torcuato%2C+Buenos+Aires!5e0!3m2!1ses-419!2sar!4v1524962514844" :width="mapWidth" height="350" frameborder="0" style="border:0" allowfullscreen></iframe>
          <p class="subheading pt-4">
            <v-icon class="mr-3">phone</v-icon>
            (011) 15 3114 5413
            <i class="fab fa-whatsapp ml-2 wp-icon" aria-hidden="true"></i>
          </p>
          <p class="subheading"><v-icon class="mr-3">email</v-icon>info@carano.com.ar</p>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import axios from 'axios'
  export default {
    mixins: [validationMixin],

    validations: {
      name: { required },
      email: { required, email },
      query: { required },
    },

    data: () => ({
      mapWidth: 600,
      mapClass: 'px-5 mt-5',
      btnSmall: false,
      displayTitle: 'display-4',
      name: '',
      email: '',
      query: '',
      loadingBtn: false,
      alertQuery: false
    }),

    computed: {
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.required && errors.push('Este campo es obligatorio.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Introduce un correo electronico valido')
        !this.$v.email.required && errors.push('Este campo es obligatorio.')
        return errors
      },
      queryErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.required && errors.push('Este campo es obligatorio.')
        return errors
      }
    },

    methods: {
      submit () {
        this.$v.$touch()
        if(this.nameErrors.length === 0 && this.emailErrors.length === 0 && this.queryErrors.length === 0) {
          this.loadingBtn = true;
          const vm = this;
          axios.post('/mail.php', {
          name: this.name,
          email: this.email,
          query: this.query
          })
          .then(res => {
            vm.loadingBtn = false;
            vm.alertQuery = true;
            setTimeout(() => {
            vm.alertQuery = false;
          }, 2500)
          })
          .catch(error => console.log(error));
        }
      },
      clear () {
        this.$v.$reset()
        this.name = ''
        this.email = ''
        this.query = ''
      }
    },
    mounted() {
      console.log(window.innerWidth)
      if(window.innerWidth < 1024 && window.innerWidth > 600) {
        this.displayTitle = 'display-3';
        this.mapWidth = 400;
      } else if(window.innerWidth < 600) {
        this.mapWidth = 250
        this.displayTitle = 'display-3';
        this.btnSmall = true;
        this.mapClass = 'px-2 mt-5'
      }
    }
  }
</script>

<style scoped>

.main-contact {
  background-color: #ececec;
}

.wp-icon {
  font-size: 1.15em;
  color: #4CAF50;
}

.alert-show {
  height: 80px;
  margin-bottom: 15px;
  display: block;
  overflow: hidden;
}

.alert-in-enter-active {
  animation: alert-in 0.5s ease-in-out;
}

@keyframes alert-in {
  from {transform: translateY(-100px)}
  to {transform: translateY(0)}
}

.alert-in-leave-active {
  animation: alert-out 0.5s ease-in-out;
}

@keyframes alert-out {
  from {transform: translateY(0)}
  to {transform: translateY(-100px)}
}

</style>





// WEBPACK FOOTER //
// src/components/sections/Contact.vue